@import 'styles/mixins';
@import 'styles/blaze/mixins';

.card {
  position: relative;
  border-radius: 12px;
  background: #fff;
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 0;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 12px;
    border: 1px solid var(--dark-8);
    pointer-events: none;
    z-index: 1;
  }
}

.headerRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
  z-index: 2;
}

.headerLeft {
  display: flex;
  align-items: center;
  gap: 8px;
}

.divider {
  height: 1px;
  background: var(--dark-4);
  margin: 16px 0;
  width: 100%;
}

.detailsSection {
  margin-bottom: 16px;
}

.controlsRow {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-top: auto;
}

.trialControlsRow {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-top: auto;
}

.managePlanButton {
  flex-shrink: 0;
}

.canceledPill {
  border-radius: 4px;
  font-size: 12px;
}
